var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAuction2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.1429 11.7132L13.3645 11.935C13.5786 12.15 13.8642 12.2685 14.1683 12.2685C14.4723 12.2685 14.7579 12.15 14.9717 11.9354L18.0017 8.90343C18.2166 8.68912 18.3349 8.40336 18.3349 8.0991C18.3349 7.79484 18.2166 7.50908 18.002 7.29512L17.7801 7.07303C17.6321 6.92498 17.3924 6.92498 17.2445 7.07303L13.1429 11.1773C12.9949 11.3253 12.9949 11.5652 13.1429 11.7132Z",
    fill: "#252153"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.28403 6.85085C8.358 6.9249 8.45495 6.9619 8.55186 6.9619C8.64877 6.9619 8.74568 6.9249 8.81969 6.85085L12.9213 2.74659C13.0692 2.59854 13.0692 2.35866 12.9213 2.21061L12.6997 1.98888C12.2713 1.55876 11.52 1.55912 11.0924 1.98852L8.06244 5.02042C7.84753 5.23473 7.72917 5.52049 7.72917 5.82475C7.72917 6.12901 7.84753 6.41477 8.06209 6.62873L8.28403 6.85085Z",
    fill: "#252153"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0713 10.6412C12.1453 10.7153 12.2422 10.7523 12.3392 10.7523C12.4361 10.7523 12.533 10.7153 12.607 10.6412L16.7085 6.53695C16.8565 6.38891 16.8565 6.14903 16.7085 6.00098L13.9919 3.28254C13.8439 3.1345 13.6042 3.1345 13.4563 3.28254L9.35474 7.38681C9.20676 7.53486 9.20676 7.77474 9.35474 7.92279L9.89937 8.46778C6.9661 11.0112 3.19603 14.66 2.11186 15.7449C1.82553 16.0314 1.66797 16.4119 1.66797 16.8169C1.66797 17.6531 2.34748 18.333 3.18313 18.333C3.58782 18.333 3.96808 18.1754 4.25441 17.8889C5.55949 16.5829 9.11716 12.8962 11.5358 10.1053L12.0713 10.6412Z",
    fill: "#252153"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0618 14.5452H10.7587C9.50547 14.5452 8.486 15.5537 8.486 16.8069C8.486 17.6425 9.16551 18.3221 10.0012 18.3221H16.8194C17.655 18.3221 18.3345 17.6426 18.3345 16.8069C18.3345 15.5537 17.315 14.5452 16.0618 14.5452Z",
    fill: "#252153"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAuction2);
export default __webpack_public_path__ + "static/media/auction2.c8de1bb698881487fe503375f6fc50c6.svg";
export { ForwardRef as ReactComponent };